import { IpaType } from "../phonemes/ipa";
import { RuleError, ruleErrorToString } from "./compileRule";
import { compileRuleSet } from "./compileRuleSet";
import { PhoneLengths } from "./lengthRules";
import { Rule } from "./rule";
import { CompiledRuleSet, RuleSet } from "./ruleSet";
import { runRulesOnRaw, ApplyRulesResult, runRulesOnIpa } from "./runRules";
import { ruleToString } from "./serializeRule";

/**
 * Use to build up a series of rules, then apply them to input phonemes
 */
export class RulesRunner {
  private rules: CompiledRuleSet;
  private failed: FailedRule[] = [];

  public constructor(rules: RuleSet | Rule[]) {
    const ruleSet: RuleSet = Array.isArray(rules) ? { rules } : rules;
    const [compiled, errors] = compileRuleSet(ruleSet);
    this.rules = compiled;
    this.failed = errors;
  }

  /** raw sentence (e.g. English) -> rules -> IPA, + any words not in dictionary */
  public runRulesOnRaw(raw: string, fallback?: (word: string) => string): [IpaType, string[]] {
    return runRulesOnRaw(raw, this.rules, fallback);
  }

  /** apply all the rules to the given sentence, either ipa or synth */
  public runRulesOnIpa(sentence: string): ApplyRulesResult {
    return runRulesOnIpa(sentence, this.rules);
  }

  /** any rules that failed to compile */
  public getFailures(): FailedRule[] {
    return this.failed;
  }

  public getAddPhonemeLength(): PhoneLengths | undefined {
    return this.rules.addPhonemeLength;
  }
}

export interface FailedRule {
  rule: Rule;
  error: RuleError;
}

export function failedRuleToString(fr: FailedRule): string {
  const rule = ruleToString(fr.rule);
  const error = ruleErrorToString(fr.error);
  return `error in rule "${rule}" - ${error}`;
}
